import { cn } from '../../lib/cn'

/**
 * Placeholder for content that is loading. Deliberately shaped like the content
 * it replaces so the layout does not jump when the real value lands.
 *
 * `aria-hidden` because a screen reader gains nothing from grey rectangles; the
 * container that owns them carries `aria-busy` instead.
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        'relative overflow-hidden rounded bg-surface-muted',
        'after:absolute after:inset-0 after:-translate-x-full after:animate-shimmer',
        'after:bg-gradient-to-r after:from-transparent after:via-foreground/5 after:to-transparent',
        className,
      )}
    />
  )
}
